import React, { useEffect, useState } from "react";
import { withSitecoreContext } from "@sitecore-jss/sitecore-jss-react";
import { CSSTransition } from "react-transition-group";
import Notification from "./Notification/index";
import { userDataApiCall } from "@clarion/foundation/dist/Utils/apiUtils";
import "./index.css";
const Notifications = ({
  rendering,
  sitecoreContext
}) => {
  const pageId = sitecoreContext.route.itemId;
  const [criticalNotifications, setCriticalNotifications] = useState([]);
  const [severeNotifications, setSevereNotifications] = useState([]);
  const [generalNotifications, setGeneralNotifications] = useState([]);
  const [notificationsAmount, setNotificationsAmnount] = useState(null);
  useEffect(() => {
    const dto = {
      pageId: pageId
    };
    userDataApiCall("/api/notification/current-user", rendering, dto).then(data => {
      const critical = [];
      const severe = [];
      const general = [];
      const dismissedNotifications = JSON.parse(window.localStorage.getItem("dismissedNotifications")) || [];
      let amount = null;
      data.Notifications.forEach(item => {
        if (dismissedNotifications.indexOf(item.Id) >= 0) {
          return;
        }

        // Sort notification in order of severity
        switch (item.Severity) {
          case "Critical":
            {
              critical.push(item);
              break;
            }
          case "Severe":
            {
              severe.push(item);
            }
            break;
          default:
            {
              general.push(item);
            }
        }
        amount += 1;
      });
      setNotificationsAmnount(amount);
      setCriticalNotifications(critical);
      setSevereNotifications(severe);
      setGeneralNotifications(general);
    });
  }, [pageId]);
  return /*#__PURE__*/React.createElement(CSSTransition, {
    in: notificationsAmount,
    classNames: "notifications-fade",
    timeout: 300,
    appear: true,
    unmountOnExit: true
  }, /*#__PURE__*/React.createElement("div", {
    className: "notifications"
  }, (criticalNotifications || []).map((item, i) => {
    return /*#__PURE__*/React.createElement(Notification, {
      key: i,
      type: "critical",
      data: item,
      notificationsAmount: notificationsAmount,
      setNotificationsAmnount: setNotificationsAmnount
    });
  }), (severeNotifications || []).map((item, i) => {
    return /*#__PURE__*/React.createElement(Notification, {
      key: i,
      type: "severe",
      data: item,
      notificationsAmount: notificationsAmount,
      setNotificationsAmnount: setNotificationsAmnount
    });
  }), (generalNotifications || []).map((item, i) => {
    return /*#__PURE__*/React.createElement(Notification, {
      key: i,
      type: "normal",
      data: item,
      notificationsAmount: notificationsAmount,
      setNotificationsAmnount: setNotificationsAmnount
    });
  })));
};
const NotificationsWithSitecoreContext = withSitecoreContext()(Notifications);
export default NotificationsWithSitecoreContext;